import { whenNegative } from '@execonline-inc/numbers';
import { always } from '@kofno/piper';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import { T } from '../../../../Translations';
import { chatMetadataStore } from '../../ChatStores/ChatMetadataStore';
import { ProductLicenses } from '../../ChatStores/ChatMetadataStore/Types';

interface Props {
  active: boolean;
  productLicenses: ProductLicenses;
}

function LicensePicker({ active, productLicenses }: Props) {
  const licenseIsSelected = (licenseId: number): boolean => {
    return (
      chatMetadataStore.selectedProductLicense
        .map((selectedLicense) => selectedLicense.id)
        .getOrElseValue(0) === licenseId
    );
  };

  const formatDate = (date: Date): string => {
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  return (
    <div
      id="chat-license-picker"
      className={clsx(
        active ? 'block' : 'hidden',
        'z-[1000]',
        'absolute bottom-full mb-4 ml-4 mr-2 flex-col p-4 bg-white border-1 border-gray-200 rounded text-sm shadow-sm',
      )}
    >
      <p className="mb-3 font-medium text-base">
        <T kind="Select a License" />
      </p>
      <p className="text-gray-700 mb-6 text-xs">
        <T kind="EXO will only recommend programs that are included with the selected license." />
      </p>
      <div className="space-y-6">
        {productLicenses.map((license) => (
          <div key={license.id} className="flex items-start">
            <div className="flex items-center h-5 mt-1">
              <div
                className={`w-5 h-5 rounded-full border-2 flex items-center justify-center hover:cursor-pointer ${
                  licenseIsSelected(license.id)
                    ? 'border-teal-600 bg-white'
                    : 'border-gray-300 bg-white'
                }`}
                onClick={() => chatMetadataStore.updateSelectedProductLicense(license.id)}
              >
                {licenseIsSelected(license.id) && (
                  <div className="w-3 h-3 rounded-full bg-teal-600" />
                )}
              </div>
            </div>
            <div className="ml-3 text-sm">
              <div className="flex items-center">
                <span className="text-sm font-medium text-gray-900">
                  {license.name}
                  <span className="ml-2 text-gray-600 text-xs font-normal">
                    (
                    {whenNegative(license.quantityAvailable)
                      .map(always(0))
                      .getOrElseValue(license.quantityAvailable)}{' '}
                    <T kind="remaining" />){' '}
                  </span>
                </span>
              </div>
              <p className="text-gray-700 mt-1 text-xs">
                <T kind="Starts" /> {formatDate(license.startOn)} | <T kind="Expires" />{' '}
                {formatDate(license.endOn)}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default observer(LicensePicker);
